// DS: i8.2
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
const Info = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm0 6a1 1 0 01.993.883L13 11v5a1 1 0 01-1.993.117L11 16v-5a1 1 0 011-1zm0-3a1 1 0 01.117 1.993L12 9l-.117-.007A1 1 0 0112 7z"
    })));
Info.displayName = 'Info';
export default Info;
